// ============================================================================
// ROPE - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'rope',
  name: 'Rope',
  category: 'Data Structures',
  complexity: {
    time: 'O(log N) per operation',
    space: 'O(N)'
  },
  description: 'A data structure for efficiently storing and manipulating very long strings. Implemented as a binary tree where leaves contain substrings, enabling efficient insertions, deletions, and concatenations in logarithmic time.'
};
